/**
 * Shorter than that, a list scrolls faster by hand than through the index strip.
 */
export const ALPHABET_INDEX_MIN_LETTERS = 4;

/**
 * The strip is a scrolling aid: it shows itself while the list moves, then gets
 * out of the way of the rows once the reader has settled.
 */
export const ALPHABET_INDEX_IDLE_HIDE_MS = 3500;

/**
 * Strip entry standing for the bookmarked section listed above the alphabet; it
 * is drawn as a bookmark icon rather than as a letter.
 */
export const FAVORITES_INDEX_KEY = 'favorites';

/**
 * Letter under a pointer sliding along the strip, the strip being split into as
 * many equal bands as it has letters. A pointer dragged past either end keeps
 * the closest letter rather than losing the selection.
 */
export function letterAtRatio(letters: string[], ratio: number): string | null {
  if (letters.length === 0) return null;
  const index = Math.floor(ratio * letters.length);
  return letters[Math.min(letters.length - 1, Math.max(0, index))];
}

/**
 * Closest scrolling ancestor: the strip spans the height of whatever actually
 * scrolls the list, which is the page `.content` on a standalone list and the
 * sub-tab pane inside the schedules page.
 */
export function findScrollViewport(element: HTMLElement | null | undefined): HTMLElement | null {
  let node = element?.parentElement ?? null;
  while (node) {
    const { overflowY } = window.getComputedStyle(node);
    if (overflowY === 'auto' || overflowY === 'scroll') return node;
    node = node.parentElement;
  }
  return null;
}
